<template>
    <div>
        <div>
            renderer-layout
        </div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "admin"
    }
</script>

<style scoped>

</style>